import './core'
import { Carousel_CoreInit, Form_CoreInit, Mobile, Accordion } from './core'
import Header from './modules/header'

Carousel_CoreInit();
Form_CoreInit([
  {
    classSelector: 'builder-form',
    formOptions: {
      floating_labels: true,
    },
  }
])

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    //scroll: $(window).ScrollEvents(),
  }

  Header.init()

  /* Fade-in elements */
  $('.fade-in, .slide-in').each(function() {
    $(this).FadeIn()
  })

  $('html').on('touchstart', function(){
    $('.card-client').each(function() {
      $(this).click(function() {
        $(this).toggleClass('--overlay')
      })
      if ($(this)[0].hasAttribute("href")) {
        var href = $(this).attr('href');
        $(this).removeAttr('href');
        var link = $('<a href="' + href + '" target="_blank" class="card-client__cta">Visiter leur site Web</a>');
        link.insertAfter($(this).find('.card-client__description'));
      }
    })
  });
})
